import React, { useRef, useState } from 'react'
import { withApollo, compose } from 'react-apollo'
import { useDispatch, useSelector } from 'react-redux'
import {
  createBank,
  deleteBank,
  getBank,
  updateBank
} from '../../modules/bank'

import {
  message,
  Card,
  Table,
  Divider,
  Popconfirm,
  Button,
  Input,
  Icon,
  Tag
} from 'antd'

import { useDeepEffect } from '../../utils/hooks'
import _ from 'lodash'
import Highlighter from 'react-highlight-words'
import BanksForm from './components/BanksForm'

const Banks = () => {
  const dispatch = useDispatch()
  let searchInput = useRef(null)
  const [visible, setVisible] = useState(false)
  const [formData, setFormData] = useState({})
  const [searchText, setSearchText] = useState('')

  const { banks, isLoading } = useSelector(
    (state) => ({
      banks: state.bank.bank,
      isLoading: state.bank.isLoading
    }),
    []
  )

  useDeepEffect(() => {
    async function fetch() {
      await dispatch(getBank())
    }

    fetch()
  }, [])

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            searchInput = node
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}>
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select())
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  })

  const handleSearch = (selectedKeys, confirm) => {
    confirm()
    setSearchText(selectedKeys[0])
  }

  const handleReset = (clearFilters) => {
    clearFilters()
    setSearchText('')
  }

  const refetchData = async () => { }

  const onClick = (e, record) => {
    e.preventDefault()
    setVisible(true)
    setFormData(record)
  }
  const onCloseModal = async () => {
    await dispatch(getBank())
    await setVisible(false)
  }

  const onOk = async (data) => {
    if (!_.isEmpty(formData)) {
      await dispatch(updateBank(data))
    } else {
      await dispatch(createBank(data))
    }

    await dispatch(getBank())
    await setVisible(false)
    await setFormData({})
  }

  const onDelete = async (id) => {
    await dispatch(deleteBank(id))
    await dispatch(getBank())
  }
  const columns = [
    {
      title: 'ธนาคาร',
      dataIndex: 'bankName',
      key: 'bankName',
      ...getColumnSearchProps('bankName'),
      render: (name, row) => (
        <div>
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={name.toString()}
          />
        </div>
      )
    },
    {
      title: 'Action',
      key: 'action',
      fixed: 'right',
      width: 100,
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="edit"
            onClick={(e) => {
              onClick(e, record)
            }}
          />
          <Divider type="vertical" />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => onDelete(record.id)}>
            <Button type="danger" size="small" shape="circle" icon="delete" />
          </Popconfirm>
        </span>
      )
    }
  ]

  return (
    <Card
      title="Banks"
      extra={
        <div>
          <Button size="small" icon="plus" onClick={(e) => onClick(e)}>
            Create Banks
          </Button>
          <Button size="small" icon="reload" onClick={() => refetchData()}>
            Reload
          </Button>
        </div>
      }>
      <Table
        loading={isLoading}
        scroll={{ x: 1000 }}
        rowKey={(record) => record.id}
        dataSource={banks}
        columns={columns}
      />
      <BanksForm
        visible={visible}
        onOk={onOk}
        onCancel={onCloseModal}
        formData={formData}
      />
    </Card>
  )
}

export default compose(
  withApollo
)(Banks)
